function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockclockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.13 5.07a7.5 7.5 0 018.173 1.627l1.902 1.901h-1.94a.75.75 0 100 1.5h3.75a.75.75 0 00.75-.75v-3.75a.75.75 0 00-1.5 0v1.94l-1.901-1.902a9 9 0 100 12.728.75.75 0 00-1.06-1.06A7.5 7.5 0 119.13 5.07z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5a.75.75 0 00-1.5 0V12a.75.75 0 00.387.656l3.885 2.243a.75.75 0 00.75-1.298l-3.522-2.034V7.5z",
    fill: props.fill
  }));
}

export default SvgClockclockwise;